import Layout from '../modules/Layout';
import Article from '../modules/Article';
import { CustomNextPage } from '../lib/types';
import { bootstrap } from '../lib/bootstrap';
import {
  apolloClientSanityQuery,
  useSanityQuery,
  getBlockQuery,
  getFileQuery
} from '../lib/core/useSanityQuery';
import { TermsOfUsePageQuery } from '../types/sanity-types';

const query = `
*[_id == "global-termsOfUsePage"][0] {
  ...,
  ${getBlockQuery('intro')},
  ${getBlockQuery('content')},
  ${getFileQuery('file')}
}
`;

const TermsOfUsePage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const variables = {
    query
  };
  const { url, statusCode } = props;
  const termsOfUsePageQueryResult = useSanityQuery<TermsOfUsePageQuery>({
    variables
  });

  const { data, loading } = termsOfUsePageQueryResult;

  return (
    <Layout
      statusCode={statusCode}
      title={data?.title}
      url={url}
      loading={loading}
      render={({ appContent }) => {
        if (!data) {
          const err = new Error('Terms of use page not found');
          err.code = 'ENOENT';
          throw err;
        }
        return (
          <Article
            data={{
              slugsByLocale: null,
              title: data.title,
              heading: data.heading || null,
              intro: data.intro || null,
              file: data.file || null,
              content: data.content || null
            }}
            appContent={appContent}
          />
        );
      }}
    />
  );
};

TermsOfUsePage.getInitialProps = async ctx => {
  const termsOfUsePageQueryResult = await apolloClientSanityQuery<
    TermsOfUsePageQuery
  >(ctx, { query });

  let statusCode: number | undefined;
  if (!termsOfUsePageQueryResult.data) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return { statusCode };
};

export default bootstrap(TermsOfUsePage);
